import connectionSpeedService from '../services/connectionSpeed';
import { analytics, logEvent } from '../config/firebase.config';
import { wakeupFunctions } from '../services/firebaseFunctions';
import { activityTracker } from '../utils/activityTracker';
import { ensureThemeColour } from './controller';
import { setAppField, useAppStore } from './store';

const DESKTOP_MEDIA_QUERY = '(min-width: 1024px) and (pointer: fine)';
const THUMB_RESOLUTION_REFRESH_MS = 60000;

let initialized = false;

async function updateThumbResolution() {
  try {
    const quality = await connectionSpeedService.getConnectionQuality();
    const resolution = connectionSpeedService.getThumbnailResolution(quality);
    console.log(`[AppRuntime] Connection quality: ${quality}, thumbResolution: ${resolution}px`);
    setAppField('thumbResolution', resolution);
  } catch (error) {
    console.warn('[AppRuntime] Connection speed check failed:', error);
  }
}

function initDesktopUiWatcher() {
  if (typeof window === 'undefined' || !window.matchMedia) return;

  const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
  const update = () => setAppField('isDesktopUI', mediaQuery.matches);
  update();

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', update);
    return;
  }

  mediaQuery.addListener(update);
}

function initPaymentReturnHandling() {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get('session_id');
  const showPaymentSucess = params.get('showPaymentSucess');

  if (!sessionId && !showPaymentSucess) return;

  console.log('[AppRuntime] Payment return detected', {
    sessionId: sessionId || 'none',
    uiDev: !!showPaymentSucess,
  });

  const { setShowSuccessNotification, setShowQuotaModal } = useAppStore.getState();
  setShowSuccessNotification(true);
  setShowQuotaModal(false);

  const newUrl = new URL(window.location.href);
  if (sessionId) newUrl.searchParams.delete('session_id');
  if (showPaymentSucess) newUrl.searchParams.delete('showPaymentSucess');
  window.history.replaceState({}, '', newUrl);

  window.setTimeout(() => {
    useAppStore.getState().setShowSuccessNotification(false);
  }, 5000);
}

function initQaFlags() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('testIOSPWA') === 'true' || params.get('testIOSPWA') === '1') {
    console.log('[AppRuntime] testIOSPWA parameter detected – auto-opening iOS install instructions');
    setAppField('showIOSInstallManual', true);
  }
}

function initAnalytics() {
  if (!analytics) return;

  try {
    logEvent(analytics, 'page_view', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_location: window.location.href,
      page_referrer: document.referrer,
    });
  } catch (error) {
    console.error('[AppRuntime] Error sending page_view event:', error);
  }

  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  if (!utmSource) return;

  try {
    logEvent(analytics, 'campaign_details', {
      source: utmSource,
      medium: urlParams.get('utm_medium'),
      campaign: urlParams.get('utm_campaign'),
    });
  } catch (error) {
    console.error('[AppRuntime] Error sending campaign_details event:', error);
  }
}

export function ensureAppRuntime() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  ensureThemeColour('rgb(30, 41, 59)');
  activityTracker.updateLastActivity();
  initDesktopUiWatcher();
  initPaymentReturnHandling();
  initQaFlags();
  initAnalytics();

  wakeupFunctions().catch((error) => {
    console.warn('[AppRuntime] Function wakeup failed:', error);
  });

  void updateThumbResolution();
  window.setInterval(() => {
    void updateThumbResolution();
  }, THUMB_RESOLUTION_REFRESH_MS);
}
